import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubMembershipListApi = (data) => API.get(`${URL.CLUB_MEMBERSHIP_LIST}`, data)
